<style scoped>

  * {
    margin: 0;
    padding: 0;
  }

  #main {
    height: 100vh;
    background: #ffffff !important; 
    background: -webkit-linear-gradient(to top, #ffffff, #2C2375) !important; 
    background: linear-gradient(to top, #ffffff, #2C2375) !important;
  }

  #container {
    width: 350px;
    height: 460px;
    position: absolute;
    overflow: hidden;
    top: 53%;
    left: 50%;
    margin-left: -175px;
    margin-top: -250px;
    border-radius: 8px;
    background-color: #FFFFFF;
    border-style: solid;
    border-width: 1px;
    border-color: #DDDDDE;
  }

  #title {
    margin-top: 15px;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: bold;
  }

  img {
    padding: 15px 25px 15px 25px;
  }

  #login-form {
    padding: 8px 20px 20px 20px;
  }

  #submit-button {
    margin-top: 20px;
    margin-bottom: 25px;
    background-color: #2D2675 !important;
  }

</style>

<template>

  <div id="main" class="app-bg">

    <div id="container" class="animated fadeIn">

      <div class="ui middle aligned center aligned grid">

        <div class="column">

          <div id="title">
            <span v-if="env == 'test'" class="red text">Portal Corporativo - HML</span>
            <span v-else>Portal Corporativo</span>
          </div>

          <div class="ui divider"></div>

          <img class="ui middle aligned medium image" src="/assets/images/logo.png">

          <form id="login-form" @submit.prevent="onLogin()" class="ui form">

            <div class="ui field">
              <div class="ui left icon large input">
                <i class="user icon"></i>
                <input type="text" placeholder="Login ou e-mail" v-model="login">
              </div>
            </div>

            <div class="ui field">
              <div class="ui left icon large input">
                <i class="key icon"></i>
                <input type="password" placeholder="Senha" v-model="password">
              </div>
            </div>

            <button type="submit" id="submit-button" class="ui fluid large black button" :class="{ 'loading': loading }">
              Entrar
            </button>

            <a class="grey text clickable" @click="showPswRecoveryDialog()">
              Esqueci minha senha
            </a>

            <div class="m-t-20 clickable" @click="showFirstAccessDialog()">
              <a>Primeiro acesso ?</a>
            </div>            

          </form>

        </div>

      </div>

    </div>    

    <div id="psw-recovery-dialog" class="ui tiny modal psw-recovery-modal">

      <div class="ui header">
        Recuperação de senha
      </div>

      <div class="content">

        <p class="grey text">Informe seu e-mail no campo abaixo para redefinir sua senha</p>

        <form class="ui form m-t-10" @submit.prevent="onPasswordRecovery()">
          <div class="ui field">
            <div class="ui left icon large input">
              <input type="text" placeholder="E-mail" v-model="recoveryEmail">
              <i class="envelope icon"></i>
            </div>
          </div>
        </form>        

      </div>

      <div class="actions">
        <button class="ui cancel basic button">
          <i class="times icon"></i>
          Cancelar
        </button>
        <button type="button" class="ui blue button" :class="{ loading: recovering }" @click="onPasswordRecovery()">
          <i class="check icon"></i>
          Enviar
        </button>
      </div>

    </div>      

    <register-dialogs @onCreateUser="onCreateUser" /> 
    <password-update-dialog ref="passwordUpdateDialog" @onConfirm="confirmLogin()" />

  </div>

</template>

<script>
  
  import config from "../../config.json"
  import AuthService from "@/services/auth-service"
  import Message from "@/utils/message"  
  import RegisterDialogs from "./register/index.vue"
  import PasswordUpdateDialog from "@/components/password-update-dialog.vue"  

  export default {

    data() {
      return {
        env: config.env,
        login: "",
        password: "",
        loading: false,
        recoveryEmail: "",
        recovering: false,
      }
    },

    components: { 
      RegisterDialogs, 
      PasswordUpdateDialog,
    },

    beforeDestroy() {
      $(".psw-recovery-modal").remove()
    },

    methods: {

      async onLogin() {

        if (this.loading || !this.validLogin())
          return

        this.loading = true

        try {

          const data = await AuthService.login(this.login, this.password)     
          
          if (data.user.isPswChanged) {
            this.confirmLogin()
          } else {
            this.$refs.passwordUpdateDialog.show({
              showCurrentPasswordInput: false,
              currentPassword: this.password,              
            })
          }          
          
        } catch (error) {
                    
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      validLogin() {

        let isOk = true
        let message = ""

        if (!this.login) {
          message = "Informe seu login ou e-mail"
        } else if (!this.password) {
          message = "Informe sua senha"
        }

        if (message) {
          isOk = false
          Message.info(message)
        }

        return isOk
      },

      confirmLogin() {

        this.$store.commit("setLoggingIn", true) 

        let route = "/"

        if (this.$isCustomerOrProspect())
          route = "products/search"

        this.$router.push(route)

      },

      showFirstAccessDialog() {
        $("#first-access-dialog").modal("show")
      },

      showPswRecoveryDialog() {

        $("#psw-recovery-dialog").modal("show")
      },

      async onPasswordRecovery() {

        if (!this.recoveryEmail) {
          Message.info("Informe seu e-mail")
          return
        }

        this.recovering = true

        try {

          await AuthService.passwordRecovery(this.recoveryEmail)

          this.recovering = false

          $("#psw-recovery-dialog").modal("hide")

          Message.success("E-mail enviado para " + this.recoveryEmail)

          this.recoveryEmail = ""
          
        } catch (error) {
          
          this.recovering = false          
          this.$errorHandler(error)
        } 
      },

      onCreateUser(user) {

        this.login = user.login
        this.password = user.password

        this.onLogin()
      },
    },
  }

</script>
